import { render, staticRenderFns } from "./AdminNav.vue?vue&type=template&id=41725eb3&"
import script from "./AdminNav.vue?vue&type=script&lang=js&"
export * from "./AdminNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports